const campaignFormActionTypes = {
    CAMPAIGN_MODAL_SHOW : 'CAMPAIGN_MODAL_SHOW',
    CAMPAIGN_MODAL_HIDE : 'CAMPAIGN_MODAL_HIDE',
}

export default campaignFormActionTypes;
